import { render, staticRenderFns } from "./LabelsListing.vue?vue&type=template&id=5f4e5739&"
import script from "./LabelsListing.vue?vue&type=script&lang=js&"
export * from "./LabelsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports